import React from 'react';
import { Progress } from 'reactstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faMapLocation } from '@fortawesome/free-solid-svg-icons';
import { httpClient } from '@s20/services/httpClient';
import {
    createDataSource, createGridOptions, DataGrid, indexCellRenderer, LinkCellRenderer, TextFilterDefaults,
} from '../common/dataGrid/DataGrid';
import DataGridSelectFilter from '../common/dataGrid/DataGridSelectFilter';
import CommonContext, { agGridConstants, ApiRoutes, AppNavPaths } from '../Common';
import { PageHeading, PageWrap } from '../common/forms/FormElements';
import DataGridSelectFloatingFilter from '../common/dataGrid/DataGridSelectFloatingFilter';
import DataGridToolbar from '../common/dataGrid/DataGridToolbar';

class DispatchGroupIndex extends React.Component {
    static contextType = CommonContext;

    constructor(props) {
        super(props);
        this.state = {
            loading: true,
        };
    }

    componentDidMount() {
        return this.populateState();
    }

    populateState = async () => {
        const gridOptions = createGridOptions(this);

        const [dispatchLocations] = await Promise.all([
            httpClient.js(ApiRoutes.typeAheads.dispatchLocations()),
        ]);

        const dispatchFilterParams = {
            suppressFilterButton: true,
            options: dispatchLocations,
            optionsLabel: 'label',
            optionsValue: 'value',
            disableFilter: (dispatchLocations || []).length === 1,
            initialFilterValue: null,
        };

        gridOptions.components = {
            selectFilter: DataGridSelectFilter,
            selectFloatingFilter: DataGridSelectFloatingFilter,
            nameRenderer: LinkCellRenderer,
        };

        gridOptions.columnDefs = [
            {
                flex: 0,
                width: 70,
                minWidth: 70,
                maxWidth: 70,
                headerName: '',
                valueGetter: 'node.id',
                sortable: false,
                cellRenderer: indexCellRenderer,
            },
            {
                colId: 'Name',
                sortable: true,
                headerName: 'Group Name',
                field: 'name',
                flex: 0,
                width: 300,
                minWidth: 300,
                filter: agGridConstants.columnFilterTypes.text,
                floatingFilter: true,
                filterParams: TextFilterDefaults,
                sort: { direction: 'asc', priority: 0 },
                cellRenderer: 'nameRenderer',
                cellRendererParams: {
                    to: (id) => `${AppNavPaths.DispatchGroup}/${id}`,
                    nameField: 'name',
                    idField: 'id',
                    title: 'View this Group',
                },
            },
            {
                colId: 'Companies',
                headerName: 'Companies',
                sortable: false,
                minWidth: 220,
                flex: 1,
                field: 'companies',
                filter: 'selectFilter',
                floatingFilter: true,
                filterParams: { ...dispatchFilterParams },
                floatingFilterComponent: 'selectFloatingFilter',
                floatingFilterComponentParams: { ...dispatchFilterParams },
            },
        ];

        const ds = createDataSource(ApiRoutes.dispatchGroup.search(), gridOptions);

        this.setState({
            loading: false,
            gridOptions,
            dataSource: ds,
        });
    };

    render() {
        if (this.state.loading) return <Progress />;
        const { rowData, gridOptions } = this.state;

        return (
            <PageWrap>
                <PageHeading>
                    <FontAwesomeIcon
                        icon={faMapLocation}
                        className="mr-2 text-muted"
                    />
                    <span>Dispatch Groups</span>
                </PageHeading>
                <DataGridToolbar
                    entity="dispatch_group"
                    gridApi={this.state.gridApi}
                    dataSource={this.state.dataSource}
                    onAdd={() => this.context.history.push(`${AppNavPaths.DispatchGroupNew}`)}
                    addLabel="Add Group"
                    serverExportDisabled={false}
                />
                <DataGrid
                    domLayout="normal"
                    rowData={rowData}
                    gridOptions={gridOptions}
                    gridStatus={this.state.gridStatus}
                />
            </PageWrap>
        );
    }
}
export default DispatchGroupIndex;
